// extracted by mini-css-extract-plugin
export var layoutContainer = "_bu-0";
export var layoutContainerNoRounding = "_bu-6";
export var layoutContainerOpen = "_bu-5";
export var layoutContainerResizing = "_bu-1";
export var mainContent = "_bu-2";
export var resizeDivider = "_bu-3";
export var slidePanel = "_bu-4";